import helper from '../../public/common/inFrontOfPinHelper';

export const buildPalIfpV2Url = helper.buildPalIfpV2Url;

export default helper.buildPalIfpV1Url;
